import menu from './menu';

import { NavItemType } from 'types/menu';

const menuItems: { items: NavItemType[] } = {
  items: [menu]
};

export default menuItems;
